import * as ApiRoutes from "../../routes/routeConstants/apiRoutes";
import axiosInstance from "../../interceptor/axiosInstance";
import { Section, SectionMeta, Sections } from "../../models/InstituteModel/sections.model";
import { deserialize, serialize } from "serializr";
import Notification from "../../shared/components/Notification";
import { NotificationTypes } from "../../enums/notificationTypes";
import { generatePath } from "react-router-dom";
import { BranchClassRoomsModel } from "../../models/InstituteModel/branches.model";
import { PaginationModel } from "../../models/PaginationModel/pagination.model";
import { convertJSONToFormData } from "../../shared/utils/converJsonToFormData";

export default class SectionService {
  static fetchSections(
    params: any,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    axiosInstance
      .get(ApiRoutes.SECTIONS_LIST, { params })
      .then((response) => {
        const sections = deserialize(Sections, response.data["sections"]);
        const meta = deserialize(PaginationModel, response["data"]["meta"])
        onSuccess(sections, meta);
      })
      .catch((error) => {
        Notification({
          message: "Problem in fetching sections",
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }

  static fetchSectionsMeta(
    params: any,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    axiosInstance
      .get(ApiRoutes.BRANCH_SECTIONS, { params })
      .then((response) => {
        const sections = deserialize(SectionMeta, response.data["sections"]);
        onSuccess(sections);
      })
      .catch((error) => {
        Notification({
          message: "Problem in fetching sections",
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }

  static fetchBranchClassRooms(
    params: any,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    axiosInstance
      .get(ApiRoutes.BRANCH_CLASSROOMS_LIST, { params })
      .then((response) => {
        const classrooms = deserialize(
          BranchClassRoomsModel,
          response.data["branch_class_rooms"]
        );
        onSuccess(classrooms);
      })
      .catch((error) => {
        Notification({
          message: "Problem in fetching classrooms",
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }

  static showSection(
    sectionId: string,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    const API_URL = generatePath(ApiRoutes.SINGLE_SECTION, { sectionId });
    axiosInstance
      .get(API_URL)
      .then((response) => {
        const section = deserialize(Sections, response.data["section"]);
        onSuccess(section);
      })
      .catch((error) => {
        Notification({
          message: "Problem in fetching section",
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }

  static createSection(
    data: Section,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    const payload = { section: serialize(Section, data) };
    axiosInstance
      .post(ApiRoutes.SECTIONS_LIST, payload)
      .then((response) => {
        const section = deserialize(Sections, response.data["section"]);
        onSuccess(section);
      })
      .catch((error) => {
        Notification({
          message: "Problem in creating section",
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }

  static updateSection(
    sectionId: any,
    data: Section,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    const API_URL = generatePath(ApiRoutes.SINGLE_SECTION, { sectionId });
    const payload = { section: serialize(Section, data) };

    axiosInstance
      .put(API_URL, payload)
      .then((response) => {
        const section = deserialize(Sections, response.data["section"]);
        onSuccess(section);
      })
      .catch((error) => {
        Notification({
          message: "Problem in updating section",
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }

  static deleteSection(
    sectionId: any,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    const API_URL = generatePath(ApiRoutes.SINGLE_SECTION, { sectionId });
    axiosInstance
      .delete(API_URL)
      .then((response) => {
        onSuccess();
      })
      .catch((error) => {
        Notification({
          message: "Problem in deleting section",
          description: "Please try again!",
          type: NotificationTypes.ERROR,
        });
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }
}
